import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import {
    Modal,
    ModalFooter,
    ModalBody,
    Row,
    Col,
    Label,
    Spinner,
} from "reactstrap";
import FileUploader from "../../../Utilities/Helpers/FileUploader/FileUploader";
import { noImg } from "vrcore-dashboard/dist/utilities";
import AddBoxIcon from "@material-ui/icons/AddBox";
import Avatar from "@material-ui/core/Avatar";
import { Remove as RemoveIcon } from "@material-ui/icons";
import {
    Button,
    TextField,
    Chip,
    Typography,
    Select,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Divider,
    IconButton,
    Grid,
} from "@material-ui/core";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import styled from "styled-components";
import { StyledContent, StyledHeader } from "../../../styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
const QRCode = require("qrcode.react");

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
let arr = [];
let throughInspectionFlag = false;
let serviceDataFlag = false;
const AddEditModal = (props) => {
    const [isPhotoUpload, setPhotoUpload] = useState(false);
    const [addFileModal, setFileModal] = useState(false);
    const [templates, setTemplates] = useState(props.templates);
    const [categories, setCategories] = useState(props.categories);
    const [isOpen, setModalState] = useState(props.isOpen);
    const [modalType, setModalType] = useState(props.type);
    const [vehicle, setVehicle] = useState(props.vehicle);
    const [vehicleUID, setVehicleUID] = useState(props.vehicleUID);
    const [areas, setAreas] = useState(props.areas);
    const [departments, setDepartments] = useState(props.departments);
    const [profileImgBlob, setProfileImgBlob] = useState(false);
    //const [limitExceeded, setLimitExceeded] = useState(false);
    const fileUploadRef = useRef();

    const UploadFileRef = useRef();
    const { setState } = props;
    const [profile, setProfile] = useState(props.profile);

    useEffect(() => {
        setTemplates(props.templates);
        setCategories(props.categories);
        setModalState(props.isOpen);
        setModalType(props.type);
        setVehicle(props.vehicle);
        setVehicleUID(props.vehicleUID);
        setAreas(props.areas);
        setDepartments(props.departments);
        setProfile(props.profile);
    }, [
        props.templates,
        props.categories,
        props.isOpen,
        props.type,
        props.vehicle,
        props.vehicleUID,
        props.areas,
        props.departments,
        props.profile,
    ]);
    let { attached_photos = [] } = vehicle;
    if (!isOpen && modalType === "add") {
        vehicle.inspection_records = [];
        vehicle.service_data = [];
    }
    if (!isOpen && modalType === "edit") {
        if (vehicle.inspection_records === null) {
            setVehicle({
                ...vehicle,
                inspection_records: [],
            });
        }
        if (vehicle.service_data === null) {
            setVehicle({
                ...vehicle,
                service_data: [],
            });
        }
    }
    function handleClick() {
        props.close();
        setProfileImgBlob(false);
        if (modalType === "add") {
            let imageCount = vehicle.attached_photos.length;
            vehicle.attached_photos.splice(0, imageCount);
        }
    }
    return (
        <>
            <Modal isOpen={isOpen}>
                <StyledHeader>
                    <Typography variant="h5">
                        {modalType === "add" ? "Add" : "Edit"} Vehicle
                    </Typography>
                </StyledHeader>
                <StyledContent>
                    <ModalBody>
                        <ModalRow>
                            <Col>
                                <Avatar
                                    style={{
                                        width: 150,
                                        height: 150,
                                        marginLeft: 150,
                                        borderRadius: "12px",
                                        border: "2px solid #0188cc",
                                    }}
                                    src={
                                        vehicle.photo_url
                                            ? vehicle.photo_url
                                            : profileImgBlob
                                    }
                                    alt=""
                                />
                                <div
                                    style={{
                                        marginLeft: 0,
                                        position: "absolute",
                                        bottom: 0,
                                    }}
                                >
                                    <Typography variant="subtitle1">
                                        Add Image
                                    </Typography>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={fileUploadRef}
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={(event) => {
                                            if (
                                                event.target.files[0].size >
                                                1000000
                                            ) {
                                                setState(
                                                    "fileMaxSizeSnackbar",
                                                    true
                                                );
                                            } else {
                                                setVehicle({
                                                    ...vehicle,
                                                    photo_url: URL.createObjectURL(
                                                        event.target.files[0]
                                                    ),
                                                });
                                                setProfileImgBlob(
                                                    event.target.files[0]
                                                );
                                            }
                                        }}
                                    />
                                    <AddBoxIcon
                                        color="#0188cc"
                                        onClick={() => {
                                            fileUploadRef.current.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "#0188cc",
                                            height: "50px",
                                            width: "50px",
                                        }}
                                    ></AddBoxIcon>
                                    <Typography
                                        style={{ margin: "inherit" }}
                                        variant="subtitle1"
                                    >
                                        {"(< 1MB)"}
                                    </Typography>
                                </div>
                            </Col>
                        </ModalRow>
                        <br />
                        <ModalRow>
                            <Col>
                                <Typography
                                    style={{ margin: "inherit" }}
                                    variant="subtitle1"
                                >
                                    Nick Name
                                </Typography>
                                <TextField
                                    // id="serviceperiod"
                                    style={{ width: "100%" }}
                                    value={vehicle.machine_nickname}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                machine_nickname:
                                                    event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                        </ModalRow>
                        <Divider style={{ margin: 24 }} />
                        <ModalRow>
                            <Col>
                                <Label for="reg">Registration Number</Label>

                                <TextField
                                    disabled={
                                        modalType === "edit" ? true : false
                                    }
                                    id="reg"
                                    value={vehicle.machine_reg}
                                    placeholder={
                                        vehicle.machine_reg === "" &&
                                        modalType === "add"
                                            ? "Required"
                                            : ""
                                    }
                                    style={{
                                        width: "100%",
                                        border:
                                            vehicle.machine_reg === "" &&
                                            modalType === "add"
                                                ? "1px solid red"
                                                : "",
                                    }}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                machine_reg: event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Chip
                                    label="The are following characters are not allowed: '/', '\' or '|'"
                                    style={{
                                        width: "100%",
                                        background: "red",
                                        color: "white",
                                    }}
                                />
                                <Label for="description">Description</Label>

                                <TextField
                                    id="description"
                                    style={{ width: "100%" }}
                                    value={vehicle.machine_desc}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                machine_desc:
                                                    event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="nct">CRW/NCT/MOT Expiry</Label>
                                <div>
                                    <DayPickerInput
                                        id="nct"
                                        placeholder="DD-MM-YYYY"
                                        value={vehicle.machine_nct_expiry}
                                        format={"DD-MM-YYYY"}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        onDayChange={(day) => {
                                            setVehicle({
                                                ...vehicle,
                                                machine_nct_expiry: moment(
                                                    day
                                                ).format("DD-MM-YYYY"),
                                            });
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col>
                                <Label for="tax">Tax Expiry</Label>

                                <div>
                                    <DayPickerInput
                                        id="tax"
                                        placeholder="DD-MM-YYYY"
                                        value={vehicle.machine_tax_expiry}
                                        formatDate={formatDate}
                                        format={"DD-MM-YYYY"}
                                        parseDate={parseDate}
                                        onDayChange={(day) => {
                                            setVehicle({
                                                ...vehicle,
                                                machine_tax_expiry: moment(
                                                    day
                                                ).format("DD-MM-YYYY"),
                                            });
                                        }}
                                    />
                                </div>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="areas">Area's</Label>

                                <Select
                                    variant="outlined"
                                    id="areas"
                                    multiple
                                    style={{ width: "100%" }}
                                    value={vehicle.areas || []}
                                    onChange={(event) => {
                                        setVehicle({
                                            ...vehicle,
                                            areas: event.target.value,
                                        });
                                    }}
                                >
                                    {areas &&
                                        areas.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                            <Col>
                                <Label for="departments">Departments</Label>

                                <Select
                                    variant="outlined"
                                    id="departments"
                                    multiple
                                    style={{ width: "100%" }}
                                    value={vehicle.departments || []}
                                    onChange={(event) => {
                                        setVehicle({
                                            ...vehicle,
                                            departments: event.target.value,
                                        });
                                    }}
                                >
                                    {departments &&
                                        departments.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="service">Last Service</Label>

                                <div>
                                    <DayPickerInput
                                        id="service"
                                        placeholder="DD-MM-YYYY"
                                        value={vehicle.last_service_date}
                                        formatDate={formatDate}
                                        format={"DD-MM-YYYY"}
                                        parseDate={parseDate}
                                        onDayChange={(day) => {
                                            setVehicle({
                                                ...vehicle,
                                                last_service_date: moment(
                                                    day
                                                ).format("DD-MM-YYYY"),
                                            });
                                        }}
                                    />
                                </div>
                            </Col>

                            <Col>
                                <Label for="insurance">Insurance Expiry</Label>

                                <div>
                                    <DayPickerInput
                                        id="insurance"
                                        placeholder="DD-MM-YYYY"
                                        value={vehicle.machine_insurance_expiry}
                                        formatDate={formatDate}
                                        format={"DD-MM-YYYY"}
                                        parseDate={parseDate}
                                        onDayChange={(day) => {
                                            setVehicle({
                                                ...vehicle,
                                                machine_insurance_expiry: moment(
                                                    day
                                                ).format("DD-MM-YYYY"),
                                            });
                                        }}
                                    />
                                </div>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="serviceperiod">
                                    Service Period(Weeks)
                                </Label>
                                <TextField
                                    id="serviceperiod"
                                    type="number"
                                    style={{ width: "100%" }}
                                    value={vehicle.service_period}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                service_period:
                                                    event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="thoroughinspection">
                                    Thorough Inspection Period(Weeks)
                                </Label>
                                <TextField
                                    id="thoroughinspection"
                                    type="number"
                                    style={{ width: "100%" }}
                                    value={
                                        vehicle.thorough_inspection_service_period
                                    }
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                thorough_inspection_service_period:
                                                    event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="category">Machine Category</Label>

                                <Select
                                    variant="outlined"
                                    id="category"
                                    style={{ width: "100%" }}
                                    value={vehicle.machine_category || []}
                                    onChange={(event) => {
                                        setVehicle({
                                            ...vehicle,
                                            machine_category:
                                                event.target.value,
                                        });
                                    }}
                                >
                                    {categories &&
                                        categories.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="template">
                                    Inspection Templates
                                </Label>

                                <Select
                                    variant="outlined"
                                    id="template"
                                    style={{ width: "100%" }}
                                    value={vehicle.inspection_template || []}
                                    onChange={(event) => {
                                        setVehicle({
                                            ...vehicle,
                                            inspection_template:
                                                event.target.value,
                                        });
                                    }}
                                >
                                    {templates &&
                                        templates.map((e) => {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {e}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </Col>
                        </ModalRow>
                        <ModalRow>
                            <Col>
                                <Label for="comments">Comments</Label>

                                <TextField
                                    id="comments"
                                    style={{ width: "100%" }}
                                    value={vehicle.machine_comments}
                                    onChange={(event) => {
                                        if (validateString(event.target.value))
                                            setVehicle({
                                                ...vehicle,
                                                machine_comments:
                                                    event.target.value,
                                            });
                                    }}
                                />
                            </Col>
                            <Col style={{ display: "none" }}>
                                <QRCode
                                    id="QRCODE"
                                    bgColor="#FFFFFF"
                                    fgColor="#000000"
                                    level="Q"
                                    style={{ width: 150, height: 150 }}
                                    includeMargin={true}
                                    size={512}
                                    imageSettings={{
                                        height: 500,
                                        width: 500,
                                    }}
                                    value={vehicle.machine_reg}
                                    renderAs="canvas"
                                />
                            </Col>
                        </ModalRow>
                        {/* --------- Service Data------------ */}
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{
                                    backgroundColor: "#0188cc",
                                    borderRadius: "6px",
                                    height: "8px",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        borderRadius: "6px",
                                        fontSize: "15px",
                                        paddingTop: "16px",
                                    }}
                                >
                                    Add Repair/Service Records
                                </p>
                            </ExpansionPanelSummary>
                            <ModalRow>
                                <Col>
                                    {vehicle.service_data.length === 0 ? (
                                        <AddBoxIcon
                                            color="#0188cc"
                                            onClick={() => {
                                                arr = vehicle.service_data;
                                                arr.push({
                                                    service_carried_by: "",
                                                    timestamp: "",
                                                    attached_files: [],
                                                });
                                                setVehicle({
                                                    ...vehicle,
                                                    service_data: arr,
                                                });
                                            }}
                                            style={{
                                                margin: "inherit",
                                                color: "#0188cc",
                                                height: "50px",
                                                width: "50px",
                                            }}
                                        ></AddBoxIcon>
                                    ) : vehicle.service_data[
                                          vehicle.service_data.length - 1
                                      ].service_carried_by !== "" &&
                                      vehicle.service_data[
                                          vehicle.service_data.length - 1
                                      ].timestamp !== "" ? (
                                        <AddBoxIcon
                                            color="#0188cc"
                                            onClick={() => {
                                                arr = vehicle.service_data;
                                                arr.push({
                                                    service_carried_by: "",
                                                    timestamp: "",
                                                    attached_files: [],
                                                });
                                                setVehicle({
                                                    ...vehicle,
                                                    service_data: arr,
                                                });
                                            }}
                                            style={{
                                                margin: "inherit",
                                                color: "#0188cc",
                                                height: "50px",
                                                width: "50px",
                                            }}
                                        ></AddBoxIcon>
                                    ) : (
                                        ""
                                    )}
                                </Col>
                            </ModalRow>
                            <Grid container spacing={8}>
                                {vehicle.service_data &&
                                    vehicle.service_data.map((e, i) => {
                                        return (
                                            <React.Fragment>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        id="carriedby"
                                                        placeholder="Service Carried Out By"
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        value={
                                                            e.service_carried_by
                                                        }
                                                        onChange={(event) => {
                                                            let arr =
                                                                vehicle.service_data;
                                                            arr[
                                                                i
                                                            ].service_carried_by =
                                                                event.target.value;
                                                            setVehicle({
                                                                ...vehicle,
                                                                service_data: arr,
                                                            });
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <div>
                                                        <DayPickerInput
                                                            id="carriedtime"
                                                            placeholder="Timestamp"
                                                            value={e.timestamp}
                                                            formatDate={
                                                                formatDate
                                                            }
                                                            format={
                                                                "DD-MM-YYYY"
                                                            }
                                                            parseDate={
                                                                parseDate
                                                            }
                                                            onDayChange={(
                                                                day
                                                            ) => {
                                                                let arr =
                                                                    vehicle.service_data;
                                                                arr[
                                                                    i
                                                                ].timestamp = moment(
                                                                    day
                                                                ).format(
                                                                    "DD-MM-YYYY"
                                                                );
                                                                setVehicle({
                                                                    ...vehicle,
                                                                    service_data: arr,
                                                                });
                                                                // setTimestamp()
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                {typeof e.attached_files ===
                                                    "undefined" ||
                                                e.attached_files.length ===
                                                    0 ? (
                                                    <Grid item xs={12}>
                                                        <div>
                                                            <input
                                                                accept="application/pdf"
                                                                type="file"
                                                                multiple
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    let arr =
                                                                        vehicle.service_data;
                                                                    let attached_files =
                                                                        _.get(
                                                                            arr[
                                                                                i
                                                                            ]
                                                                                .attached_files,
                                                                            "attached_files"
                                                                        ) || [];
                                                                    Object.keys(
                                                                        event
                                                                            .target
                                                                            .files
                                                                    ).map(
                                                                        async (
                                                                            file_index
                                                                        ) => {
                                                                            if (
                                                                                event
                                                                                    .target
                                                                                    .files[
                                                                                    file_index
                                                                                ]
                                                                                    .size <
                                                                                10000000
                                                                            )
                                                                                await props.uploadFile(
                                                                                    event
                                                                                        .target
                                                                                        .files[
                                                                                        file_index
                                                                                    ],
                                                                                    "machine_documents",
                                                                                    (
                                                                                        status
                                                                                    ) => {},
                                                                                    (
                                                                                        newFile
                                                                                    ) => {
                                                                                        arr[
                                                                                            i
                                                                                        ].attached_files = [
                                                                                            ...attached_files,
                                                                                            newFile,
                                                                                        ];
                                                                                        setVehicle(
                                                                                            {
                                                                                                ...vehicle,
                                                                                                service_data: arr,
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                );
                                                                            else
                                                                                this.setState(
                                                                                    {
                                                                                        maxSizeExceeded: true,
                                                                                    }
                                                                                );
                                                                            return true;
                                                                        }
                                                                    );
                                                                }}
                                                                style={{
                                                                    display:
                                                                        "none",
                                                                }}
                                                                ref={
                                                                    UploadFileRef
                                                                }
                                                            />
                                                            <Button
                                                                fullWidth
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    display:
                                                                        "inline",
                                                                    backgroundColor:
                                                                        "#9F9F9F",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    UploadFileRef.current.click();
                                                                }}
                                                                variant="contained"
                                                            >
                                                                + Upload Service
                                                                Record File
                                                            </Button>
                                                            {e.attached_files && (
                                                                <List>
                                                                    {e.attached_files.map(
                                                                        (f) => {
                                                                            return (
                                                                                <ListItem>
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            f.file
                                                                                        }
                                                                                    />
                                                                                </ListItem>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            )}
                                                        </div>
                                                    </Grid>
                                                ) : (
                                                    <Grid item xs={12}>
                                                        <div>
                                                            <input
                                                                accept="application/pdf"
                                                                type="file"
                                                                multiple
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    let arr =
                                                                        vehicle.service_data;
                                                                    let attached_files =
                                                                        _.get(
                                                                            arr[
                                                                                i
                                                                            ]
                                                                                .attached_files,
                                                                            "attached_files"
                                                                        ) || [];
                                                                    Object.keys(
                                                                        event
                                                                            .target
                                                                            .files
                                                                    ).map(
                                                                        async (
                                                                            file_index
                                                                        ) => {
                                                                            if (
                                                                                event
                                                                                    .target
                                                                                    .files[
                                                                                    file_index
                                                                                ]
                                                                                    .size <
                                                                                10000000
                                                                            )
                                                                                await props.uploadFile(
                                                                                    event
                                                                                        .target
                                                                                        .files[
                                                                                        file_index
                                                                                    ],
                                                                                    "machine_documents",
                                                                                    (
                                                                                        status
                                                                                    ) => {},
                                                                                    (
                                                                                        newFile
                                                                                    ) => {
                                                                                        arr[
                                                                                            i
                                                                                        ].attached_files = [
                                                                                            ...attached_files,
                                                                                            newFile,
                                                                                        ];
                                                                                        setVehicle(
                                                                                            {
                                                                                                ...vehicle,
                                                                                                service_data: arr,
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                );
                                                                            else
                                                                                this.setState(
                                                                                    {
                                                                                        maxSizeExceeded: true,
                                                                                    }
                                                                                );
                                                                            return true;
                                                                        }
                                                                    );
                                                                }}
                                                                style={{
                                                                    display:
                                                                        "none",
                                                                }}
                                                                ref={
                                                                    UploadFileRef
                                                                }
                                                            />
                                                            <Button
                                                                fullWidth
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    display:
                                                                        "inline",
                                                                    backgroundColor:
                                                                        "#ca3f3f",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                variant="contained"
                                                            >
                                                                Uploaded File
                                                            </Button>
                                                            {e.attached_files && (
                                                                <List>
                                                                    {e.attached_files.map(
                                                                        (f) => {
                                                                            return (
                                                                                <ListItem
                                                                                    style={{
                                                                                        fontWeight:
                                                                                            "bold",
                                                                                    }}
                                                                                >
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            f.file
                                                                                        }
                                                                                    />
                                                                                </ListItem>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            )}
                                                        </div>
                                                    </Grid>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                            </Grid>
                        </ExpansionPanel>
                        {/* --------- Service Data------------ */}
                        <br />
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{
                                    backgroundColor: "#0188cc",
                                    borderRadius: "6px",
                                    height: "8px",
                                    marginTop: "8px",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        borderRadius: "6px",
                                        fontSize: "15px",
                                        paddingTop: "16px",
                                    }}
                                >
                                    Add Thorough Inspection Records
                                </p>
                            </ExpansionPanelSummary>
                            <ModalRow>
                                <Col>
                                    {vehicle.inspection_records.length === 0 ? (
                                        <AddBoxIcon
                                            color="#0188cc"
                                            onClick={() => {
                                                arr =
                                                    vehicle.inspection_records;
                                                arr.push({
                                                    inspector_name: "",
                                                    timestamp: "",
                                                });
                                                setVehicle({
                                                    ...vehicle,
                                                    inspection_records: arr,
                                                });
                                            }}
                                            style={{
                                                margin: "inherit",
                                                color: "#0188cc",
                                                height: "50px",
                                                width: "50px",
                                            }}
                                        ></AddBoxIcon>
                                    ) : vehicle.inspection_records[
                                          vehicle.inspection_records.length - 1
                                      ].inspector_name !== "" &&
                                      vehicle.inspection_records[
                                          vehicle.inspection_records.length - 1
                                      ].timestamp !== "" ? (
                                        <AddBoxIcon
                                            color="#0188cc"
                                            onClick={() => {
                                                arr =
                                                    vehicle.inspection_records;
                                                arr.push({
                                                    inspector_name: "",
                                                    timestamp: "",
                                                });
                                                setVehicle({
                                                    ...vehicle,
                                                    inspection_records: arr,
                                                });
                                            }}
                                            style={{
                                                margin: "inherit",
                                                color: "#0188cc",
                                                height: "50px",
                                                width: "50px",
                                            }}
                                        ></AddBoxIcon>
                                    ) : (
                                        ""
                                    )}
                                </Col>
                            </ModalRow>
                            <Grid container spacing={8}>
                                {vehicle.inspection_records &&
                                    vehicle.inspection_records.map((e, i) => {
                                        return (
                                            <React.Fragment>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        id="inspector"
                                                        placeholder="Inspector Name"
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        value={e.inspector_name}
                                                        onChange={(event) => {
                                                            let arr =
                                                                vehicle.inspection_records;
                                                            arr[
                                                                i
                                                            ].inspector_name =
                                                                event.target.value;
                                                            setVehicle({
                                                                ...vehicle,
                                                                inspection_records: arr,
                                                            });
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <div>
                                                        <DayPickerInput
                                                            id="time"
                                                            placeholder="Timestamp"
                                                            value={e.timestamp}
                                                            formatDate={
                                                                formatDate
                                                            }
                                                            format={
                                                                "DD-MM-YYYY"
                                                            }
                                                            parseDate={
                                                                parseDate
                                                            }
                                                            onDayChange={(
                                                                day
                                                            ) => {
                                                                let arr =
                                                                    vehicle.inspection_records;
                                                                arr[
                                                                    i
                                                                ].timestamp = moment(
                                                                    day
                                                                ).format(
                                                                    "DD-MM-YYYY"
                                                                );
                                                                setVehicle({
                                                                    ...vehicle,
                                                                    inspection_records: arr,
                                                                });
                                                                // setTimestamp()
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                            </React.Fragment>
                                        );
                                    })}
                            </Grid>
                        </ExpansionPanel>
                        <br />
                        <ModalRow>
                            <React.Fragment>
                                <input
                                    accept="application/pdf"
                                    type="file"
                                    multiple
                                    onChange={(event) => {
                                        let attached_files =
                                            _.get(vehicle, "attached_files") ||
                                            [];
                                        Object.keys(event.target.files).map(
                                            async (file_index) => {
                                                if (
                                                    event.target.files[
                                                        file_index
                                                    ].size < 10000000
                                                )
                                                    await props.uploadFile(
                                                        event.target.files[
                                                            file_index
                                                        ],
                                                        "machine_documents",
                                                        (status) => {},
                                                        (newFile) => {
                                                            attached_files = [
                                                                ...attached_files,
                                                                newFile,
                                                            ];
                                                            setVehicle({
                                                                ...vehicle,
                                                                attached_files,
                                                            });
                                                        }
                                                    );
                                                else
                                                    this.setState({
                                                        maxSizeExceeded: true,
                                                    });
                                                return true;
                                            }
                                        );
                                    }}
                                    style={{
                                        display: "none",
                                    }}
                                    ref={UploadFileRef}
                                />
                                <Button
                                    fullWidth
                                    style={{
                                        width: "100%",
                                        display: "inline",
                                        backgroundColor: "#0188cc",
                                        color: "white",
                                        marginTop: "8px",
                                    }}
                                    onClick={() => {
                                        setFileModal(true);
                                    }}
                                    variant="contained"
                                >
                                    + Upload File
                                </Button>
                                {addFileModal && (
                                    <FileUploader
                                        isOpen={addFileModal}
                                        multipleUploads={true}
                                        uploadFilesOnly={
                                            isPhotoUpload ? true : false
                                        }
                                        permittedFileType={
                                            isPhotoUpload ? "image/*" : false
                                        }
                                        closeFileUploader={() => {
                                            setFileModal(false);

                                            setPhotoUpload(false);
                                        }}
                                        callback={(files) => {
                                            if (!isPhotoUpload) {
                                                let attached_files =
                                                    _.get(
                                                        vehicle,
                                                        "attached_files"
                                                    ) || [];
                                                attached_files = [
                                                    ...attached_files,
                                                    ...files,
                                                ];
                                                setVehicle({
                                                    ...vehicle,
                                                    attached_files,
                                                });
                                            } else {
                                                let photos = [];
                                                files.map((e) => {
                                                    let timestamp = moment().format(
                                                        "DD-MM-YYYY hh:mm:ss"
                                                    );
                                                    photos.push({
                                                        photo_url: e.fileURL,
                                                        photo_timestamp: timestamp,
                                                        photo_name: e.file,
                                                    });
                                                    return null;
                                                });

                                                setVehicle((vehicle) => ({
                                                    ...vehicle,
                                                    attached_photos: photos,
                                                }));
                                            }
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        </ModalRow>

                        <ModalRow>
                            {vehicle.attached_files && (
                                <List>
                                    {vehicle.attached_files.map((e) => {
                                        return (
                                            <ListItem>
                                                <ListItemText
                                                    primary={e.file}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            )}
                        </ModalRow>

                        <ModalBody>
                            {modalType === "add" || modalType === "edit" ? (
                                <React.Fragment>
                                    <Typography
                                        style={{
                                            margin: "inherit",
                                            marginBotton: "15px",
                                        }}
                                        variant="subtitle1"
                                    >
                                        {"Vehicle Photos :"}
                                    </Typography>
                                    <br />
                                    <Grid container spacing={4}>
                                        {attached_photos &&
                                            attached_photos.map((e, i) => {
                                                return (
                                                    <Grid
                                                        xl={3}
                                                        lg={3}
                                                        xs={12}
                                                        sm={12}
                                                        md={6}
                                                        style={{
                                                            position:
                                                                "relative",
                                                        }}
                                                    >
                                                        {props.pageType !==
                                                            "view" && (
                                                            <IconButton
                                                                mini
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    let items = attached_photos;

                                                                    items.splice(
                                                                        i,
                                                                        1
                                                                    );
                                                                    setVehicle(
                                                                        (
                                                                            vehicle
                                                                        ) => ({
                                                                            ...vehicle,
                                                                            items,
                                                                        })
                                                                    );
                                                                }}
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: 0,
                                                                    right: 0,
                                                                    background:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                    height: 16,
                                                                    width: 16,
                                                                }}
                                                                size="small"
                                                            >
                                                                <RemoveIcon fontSize="inherit" />
                                                            </IconButton>
                                                        )}
                                                        <img
                                                            style={{
                                                                padding: "10px",
                                                                borderRadius:
                                                                    "25px",
                                                                width: "100%",
                                                                height: "auto",
                                                            }}
                                                            src={
                                                                e
                                                                    ? e.photo_url
                                                                    : noImg
                                                            }
                                                            alt={
                                                                e
                                                                    ? e.photo_url
                                                                    : noImg
                                                            }
                                                        />
                                                    </Grid>
                                                );
                                            })}
                                    </Grid>
                                    {/* {limitExceeded && (
                                        <div
                                            style={{
                                                background: "red",
                                                color: "white",
                                                borderRadius: "50%",
                                                padding: 4,
                                            }}
                                        >
                                            Too Many Images Selected - Limit is
                                            4 Images
                                        </div>
                                    )} */}

                                    <br />
                                    <AddBoxIcon
                                        color="#0188cc"
                                        onClick={() => {
                                            setPhotoUpload(true);
                                            setFileModal(true);
                                        }}
                                        style={{
                                            marginTop: "15px",
                                            color: "#0188cc",
                                            height: "50px",
                                            width: "50px",
                                        }}
                                    ></AddBoxIcon>
                                    <Typography
                                        style={{ margin: "inherit" }}
                                        variant="subtitle1"
                                    >
                                        {"(< 1MB)"}
                                    </Typography>
                                </React.Fragment>
                            ) : (
                                ""
                            )}
                        </ModalBody>
                    </ModalBody>
                </StyledContent>
                {vehicle.inspection_records.length !== 0 ? (
                    <>
                        {vehicle.inspection_records[
                            vehicle.inspection_records.length - 1
                        ].inspector_name === "" ||
                        vehicle.inspection_records[
                            vehicle.inspection_records.length - 1
                        ].timestamp === ""
                            ? (throughInspectionFlag = true)
                            : (throughInspectionFlag = false)}
                    </>
                ) : (
                    (throughInspectionFlag = false)
                )}
                {vehicle.service_data.length !== 0 ? (
                    <>
                        {vehicle.service_data[vehicle.service_data.length - 1]
                            .service_carried_by === "" ||
                        vehicle.service_data[vehicle.service_data.length - 1]
                            .timestamp === ""
                            ? (serviceDataFlag = true)
                            : (serviceDataFlag = false)}
                    </>
                ) : (
                    (serviceDataFlag = false)
                )}
                <ModalFooter>
                    <Button onClick={handleClick} variant="contained">
                        Cancel
                    </Button>
                    <Button
                        disabled={
                            vehicle.machine_reg === "" && modalType === "add"
                                ? true
                                : throughInspectionFlag === true ||
                                  serviceDataFlag === true
                                ? true
                                : false
                        }
                        onClick={async () => {
                            var canvas = document.getElementById("QRCODE");
                            props.setVehicle(
                                vehicleUID,
                                {
                                    ...vehicle,

                                    created_by: {
                                        uid: profile.uid,
                                        user_name:
                                            profile.first_name +
                                            " " +
                                            profile.last_name,
                                    },
                                },

                                profileImgBlob,
                                modalType === "add" ? true : false,
                                canvas.toDataURL()
                            );
                            props.setActivity(
                                modalType === "add" ? "create" : "update",
                                "vehicle",
                                vehicle.machine_reg
                            );
                            setProfileImgBlob(false);
                            arr = [];
                            setVehicle({ ...vehicle, inspection_records: arr });
                            props.close();
                        }}
                        style={{
                            backgroundColor: "#0188cc",
                            color: "white",
                        }}
                        variant="contained"
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={props.requesting} style={{ maxWidth: "00px" }}>
                <ModalBody>
                    <div
                        style={{
                            textAlign: "center",
                            paddingTop: "3em",
                        }}
                    >
                        <div
                            style={{
                                background: "white",
                                width: "fit-content",
                                display: "inline-block",
                                padding: "2em",
                            }}
                        >
                            <Spinner
                                style={{
                                    height: 100,
                                    width: 100,
                                    background: "white",
                                }}
                                color="primary"
                            />
                            <Typography
                                style={{
                                    textAlign: "center",
                                    marginTop: 15,
                                    color: "rgba(0, 0, 0, 0.87)",
                                    fontWeight: "bolder",
                                    fontSize: 20,
                                }}
                                variant="subtitle1"
                            >
                                Processing...
                            </Typography>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

const validateString = (string) => {
    if (
        !string.includes("/") &&
        !string.includes("|") &&
        !string.includes("\\")
    )
        return true;
};
export default AddEditModal;
